<template>
  <fieldset v-if="data.length" class="groups" v-for="group in data">

    <legend @click="group.hide = !group.hide" :style="'background-image: url(' +
      $model.wwwroot +
      '/pix/t/' +
      (group.hide ? 'collapsed.png' : 'expanded.png') +
      ')'
      ">
      Группа: {{ group.groupInfo.name }}
    </legend>
    <!-- список студентов -->
    <v-autocomplete v-if="!group.hide" :disabled="state == 3" :items="group.allStudents"
      v-model="group.selectedStudents" max-width="500" :multiple="true" item-title="name" return-object
      variant="outlined" clearable chips closable-chips @update:modelValue="onSelectStudent(group.selectedStudents)">
      <template v-slot:chip="{ props, item }">
        <v-chip v-bind="props" variant="flat" color="green" :text="item.raw.name"></v-chip>
      </template>

      <template v-slot:item="{ props, item }">
        <v-list-item v-bind="props" :title="item.raw.name"></v-list-item>
      </template>
    </v-autocomplete>


    <template v-if="group.selectedStudents.length != 0 && !group.hide">
      <div v-for="student in group.selectedStudents" :key="student.id">
        <br />
        <h5 v-if="student.editable || student.viewable">
          {{ student.name }}
        </h5>



        <v-container>
          <v-row>
            <template v-for="variable in student">
              <v-col v-if="
                variable != null &&
                typeof variable === 'object' &&
                variable.datatype != undefined &&
                variable.editable == 1
              " :key="variable.name" cols="4">




                <label class="cursor-pointer" v-if="variable.datatype == 'checkbox'">
                  <input type="checkbox" :name="variable.name" v-model="variable.value" />
                  {{ variable.description }}
                </label>


                <div v-if="variable.datatype == 'date'">
                  <datepicker variant="underlined" :label="variable.description" v-model="variable.value"
                    prepend-inner-icon="mdi-calendar-month"></datepicker>
                </div>

                <v-textarea v-if="
                  variable.datatype == 'raw' ||
                  variable.datatype == 'money' ||
                  variable.datatype == 'text'
                " :label="variable.description" variant="underlined" v-model="variable.value" rows="1"
                  auto-grow></v-textarea>

                <div v-if="variable.datatype == 'list'">
                  <v-autocomplete return-object clearable variant="underlined" :label="variable.description"
                    v-model="variable.value"
                    :items="possibleValues[variable.name] ? possibleValues[variable.name] : variable.list"
                    item-title="name" item-value="id">
                  </v-autocomplete>

                </div>

              </v-col>

              <v-col v-if="
                variable != null &&
                variable.datatype != undefined &&
                variable.editable != 1 &&
                variable.viewable == 1
              " :key="variable.name" cols="4">
                <v-textarea :set="(val = variable.displayed
                  ? variable.displayed
                  : variable.value)
                  " :label="variable.description" v-model="val" rows="1" auto-grow readonly></v-textarea>
              </v-col>
            </template>
          </v-row>
        </v-container>



      </div>
    </template>

  </fieldset>
</template>

<script>
import datepicker from "moodleDir/procollege/lib/vue/datepicker.vue"
export default {
  name: "defaultView",
  emits: ["update:data"],
  data() {
    return {
      abortControl: [],
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    possibleValues: {
      type: Object,
      required: true,
    },
    categoryid: {
      type: Number,
      required: true,
    },
    state: {
      required: true,
    }
  },
  components: {
    datepicker,
  },
  computed: {
    value: {
      get() {
        return this.data;
      },
      set(value) {
        this.$emit("update:data", value);
      },
    },
  },
  created() { },
  methods: {
    onSelectStudent(selectedStudents) {
      if (selectedStudents.length) {
        //уже отправленные и еще не обработанные запросы не интересны
        let abortControl_;
        while ((abortControl_ = this.abortControl.pop())) {
          abortControl_.abort();
        }
        //------------------------------------------
        abortControl_ = new AbortController();
        this.abortControl.push(abortControl_);


        let uids = selectedStudents.map(el => el.uid)
        this.axios
          .post(
            this.$model.wwwroot + "/procollege/manage_groups/documents3/checkOrderExists",
            new URLSearchParams(
              {
                uids: uids,
                categoryid: this.categoryid
              }
            ),
            {
              signal: abortControl_.signal,
            }
          )
          .then((response) => {
            this.abortControl = this.abortControl.filter(el => abortControl_ !== el)
            if (response.data.length) {
              let message = '';
              for (let key in response.data) {
                let orderlink = this.$model.wwwroot + "/procollege/manage_groups/#/documents3/document/" + response.data[key].documentid;
                let name = response.data[key].firstname + " " + response.data[key].lastname;
                message += "<p>Существует <a target='_blank' href='" + orderlink + "'>приказ</a>, находящийся в работе для " + name + "</p>";
              }
              this.$eventBus.$emit("show-dialog", {
                title: "Внимание",
                content: message,
              });

            }
          })
          .catch((error) => {
            this.abortControl = this.abortControl.filter(el => abortControl_ !== el)
            this.axiosDefaultErrorHandler(error);
          });
      }

    }
  },
};
</script>
<style scoped>
.groups legend {
  background-position: left;
  padding-left: 20px;
  cursor: pointer;
  width: auto;
}
</style>